import { render, staticRenderFns } from "./direct-debit-callback.vue?vue&type=template&id=71247707"
import script from "./direct-debit-callback.vue?vue&type=script&lang=js"
export * from "./direct-debit-callback.vue?vue&type=script&lang=js"
import style0 from "./direct-debit-callback.vue?vue&type=style&index=0&id=71247707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports